const listingInfoJson = (listingInfo) => {
  if (listingInfo) {
    const builtAddress = `${listingInfo.location_street_address} ${
      listingInfo.listing_display_specifier
        ? listingInfo.listing_display_specifier
        : ''
    }, ${listingInfo.location_postcode} ${listingInfo.location_municipality}`
    const data = {
      '@context': 'http://schema.org/',
      '@type': 'Apartment',
      numberOfRooms: `${listingInfo.room_count}ROM`,
      floorSize: `${listingInfo.area_living}MTK`,
      address: builtAddress,
      logo: 'https://storage.googleapis.com/blok-static/logo.png',
      name: builtAddress,
      description: listingInfo.listing_title,
      photo: listingInfo.hero,
      image: listingInfo.hero,
    }
    return JSON.stringify(data)
  }
  return null
}

export default listingInfoJson
